@if (!setting.configuration.uIoptions?.mergedMapAndListing) {
  @if (location) {
    <ion-card [ngClass]="{'disable-box-shadow': !this.setting.UIaddBoxShadow}">
      <ion-grid [ngClass]="{'disable-background-color': !this.setting.UIshowBackground, 'centeringBanners': !this.setting.configuration.uIoptions?.locationToPopup}" style="background: #fff;">
        <ion-row class="cardLayout">
          <div>
            <img class="location-img" [ngClass]="{'popup-location-img': this.setting.configuration.uIoptions?.locationToPopup}" [src]="getImage()">
          </div>
          <div class="multiline" style="padding-left: 10px; width: auto;">
            <ion-grid>
              <ion-row>
                <h2 class="title" [ngClass]="{'popup-title': this.setting.configuration.uIoptions?.locationToPopup}" >{{ location.DisplayName }}</h2>
              </ion-row>
              <ion-row>
                <p class="address textresize" [ngClass]="{'popup-textresize': this.setting.configuration.uIoptions?.locationToPopup}" >{{ location.FormattedAddress }}</p>
              </ion-row>
              @if (location.Phone) {
                <ion-row  >
                  <p class="textresize" style="margin-top: 0;margin-bottom: 10px;" [ngClass]="{'popup-textresize': this.setting.configuration.uIoptions?.locationToPopup}"  [innerHTML]="getNumber(location)"></p>
                </ion-row>
              }
              @if (location.__currentDayHours) {
                <ion-row class="smalltextresize" [ngClass]="{'popup-smalltextresize': this.setting.configuration.uIoptions?.locationToPopup}" >
                  {{ 'Geolocation.OpenBetween' | translate }}:
                  {{ location.__currentDayHours.OpenTime }}-{{ location.__currentDayHours.CloseTime }}
                </ion-row>
              }
              @if (!location.__currentDayHours) {
                <ion-row>
                  <ion-badge color="danger">
                    {{ 'General.ClosedOnlineOrder' | translate }}
                  </ion-badge>
                </ion-row>
              }
              <ion-row>
                @if (position) {
                  <ion-button size="small" style="margin-bottom: 0;" (click)="onDirectionClicked()">
                  {{ 'Geolocation.Direction' | translate }}</ion-button>
                }
              </ion-row>
            </ion-grid>
          </div>
        </ion-row>
      </ion-grid>
    </ion-card>
  }
}

@if (setting.configuration.uIoptions?.mergedMapAndListing) {
  @if (location) {
    <div class="store-card" [ngClass]="{'store-card-homers': homersLayout}">
      <div class="store-card-boundries">
        <div class="store-card-img" [ngClass]="{'store-card-img-homers': homersLayout}">
          <!--<img class="location-img" [src]="getImage()">-->
          <img class="location-img" src="assets/homers/store.png">

          
        </div>
        <div class="store-card-content" [ngClass]="{'store-card-content-homers': homersLayout}">
          <div class="store-card-content-storename">
            <h2 class="title" [ngClass]="{'poppinsNormalFont': homersLayout, 'fontModified': homersLayout}">{{ location.DisplayName }}</h2>
          </div>
          <div class="store-card-content-storeaddress">
            <p class="styleAddress" [ngClass]="{'poppinsNormalFont': homersLayout}">{{ location.FormattedAddress }}</p>
          </div>
        </div>
      </div>
      
    </div>
  }
}